import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";


async function loadRuntimeConfig() {
try {
const response = await fetch("/config.json", { cache: "no-store" });
if (!response.ok) {
throw new Error("Failed to load runtime config");
}
window.appConfig = await response.json();
} catch (error) {
console.warn("Runtime config not loaded, falling back to defaults.", error);
window.appConfig = {};
}
}

async function bootstrap() {


await loadRuntimeConfig();
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
}

bootstrap();